'use client';

import { ProductCard } from '@dealerportal/catalog-ui';
import type { PaginatedProduct } from '@dealerportal/common';
import { useTranslations } from '@dealerportal/i18n/client';
import { toKebab } from '@dealerportal/utilities';
import { BetterButton } from './BetterButton';

interface FeaturedVisualizableProps {
  products: PaginatedProduct[];
}

const FeaturedVisualizable: React.FC<FeaturedVisualizableProps> = ({
  products = [],
}) => {
  const t = useTranslations('ui');
  const showParentContainer = products.length > 0;
  return (
    // Wrap the conditional rendering in a Fragment to ensure it always returns something
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {showParentContainer && (
        <div>
          {/* Todo 'See all' button */}
          {/* <BetterButton
            label="See all"
            btnStyle="primary"
            className="ui-mb-5"
          /> */}
          <div className="ui-grid md:ui-grid-cols-2 lg:ui-grid-cols-4 ui-gap-4 ui-pb-4">
            {products.map((product, index) =>
              product.hasVisualization ? (
                <div
                  key={index}
                  className="ui-border-solid ui-border ui-border-gray-300 ui-rounded-md ui-overflow-hidden ui-bg-white"
                >
                  <ProductCard key={index} product={product} />
                </div>
              ) : null
            )}
          </div>
          <BetterButton
            icon='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 233.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l192-192zm-384 192l192-192c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 41.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"/></svg>'
            iconClassName="ui-order-1"
            label={t('seeAllVisualizable', {
              productType: products[0].productType,
            })}
            btnStyle="simple"
            replaceClass={{ '!ui-text-gray-950': '' }}
            href={`/p/${toKebab(products[0].productType)}?visualizable=1`}
          />
        </div>
      )}
    </>
  );
};

export default FeaturedVisualizable;
